// Module
var code = "<tags></tags>\n";
// Exports
module.exports = code;